/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FeedbackAttachmentItemResVo
 */
export interface FeedbackAttachmentItemResVo {
    /**
     * 上传文件真实主键。
     * @type {number}
     * @memberof FeedbackAttachmentItemResVo
     */
    uploadFileId?: number;
    /**
     * 可直接访问的文件地址。
     * @type {string}
     * @memberof FeedbackAttachmentItemResVo
     */
    fileUrl?: string;
    /**
     * 上传文件名称。
     * @type {string}
     * @memberof FeedbackAttachmentItemResVo
     */
    fileName?: string;
    /**
     * 文件扩展名，如 jpg、png。
     * @type {string}
     * @memberof FeedbackAttachmentItemResVo
     */
    fileType?: string;
    /**
     * 展示顺序。
     * @type {number}
     * @memberof FeedbackAttachmentItemResVo
     */
    sortNo?: number;
}

/**
 * Check if a given object implements the FeedbackAttachmentItemResVo interface.
 */
export function instanceOfFeedbackAttachmentItemResVo(value: object): value is FeedbackAttachmentItemResVo {
    return true;
}

export function FeedbackAttachmentItemResVoFromJSON(json: any): FeedbackAttachmentItemResVo {
    return FeedbackAttachmentItemResVoFromJSONTyped(json, false);
}

export function FeedbackAttachmentItemResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeedbackAttachmentItemResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'uploadFileId': json['uploadFileId'] == null ? undefined : json['uploadFileId'],
        'fileUrl': json['fileUrl'] == null ? undefined : json['fileUrl'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'fileType': json['fileType'] == null ? undefined : json['fileType'],
        'sortNo': json['sortNo'] == null ? undefined : json['sortNo'],
    };
}

export function FeedbackAttachmentItemResVoToJSON(json: any): FeedbackAttachmentItemResVo {
    return FeedbackAttachmentItemResVoToJSONTyped(json, false);
}

export function FeedbackAttachmentItemResVoToJSONTyped(value?: FeedbackAttachmentItemResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uploadFileId': value['uploadFileId'],
        'fileUrl': value['fileUrl'],
        'fileName': value['fileName'],
        'fileType': value['fileType'],
        'sortNo': value['sortNo'],
    };
}

